import type { TOC } from '@ember/component/template-only';
import ModalSubscriptionAccess from 'lumen/components/settings/users/modals/modal-subscription-access';
import type MarketSettingsUsersSubscriptionAccessController from 'lumen/controllers/market/settings/users/subscription-access';

interface MarketSettingsUsersSubscriptionAccessSignature {
  Args: {
    controller: MarketSettingsUsersSubscriptionAccessController;
  };
}

const MarketSettingsUsersSubscriptionAccess: TOC<MarketSettingsUsersSubscriptionAccessSignature> =
  <template>
    <ModalSubscriptionAccess
      @isLoading={{@controller.isLoading}}
      @isLoadingMore={{@controller.isLoadingMore}}
      @isOwnUser={{@controller.isOwnUser}}
      @onAddAccess={{@controller.addSubscriptionAccess}}
      @onBulkDelete={{@controller.bulkDelete}}
      @onClose={{@controller.close}}
      @onDelete={{@controller.deleteRelationship}}
      @onLoadMore={{@controller.onLoadMore}}
      @onSave={{@controller.saveChanges}}
      @onSearchChange={{@controller.onSearchChange}}
      @onSortChange={{@controller.onSortChange}}
      @relationships={{@controller.relationships}}
      @searchText={{@controller.searchText}}
      @sorts={{@controller.sorts}}
      @userEmail={{@controller.userEmail}}
      @userId={{@controller.userId}}
    />
  </template>;

export default MarketSettingsUsersSubscriptionAccess;
